import React from 'react';
import CustomLink from '../components/CustomLink';

const DEFAULT_BILLING_PERIOD_VALUE = 4;

function renderAgreementTerms(subscriptionData, legalLinks) {
    const { trial, price, billingPeriod } = subscriptionData;
    const billingPeriodValue = billingPeriod?.value || DEFAULT_BILLING_PERIOD_VALUE;
    const trialPeriodValue = trial?.billingPeriod?.value || DEFAULT_BILLING_PERIOD_VALUE;

    const chargeText = trial
        ? `First ${trialPeriodValue} ${trialPeriodValue === 1 ? 'week is' : 'weeks are'} ${trial.price} now, then ${price} every ${billingPeriodValue} weeks`
        : `You will be charged ${price} now and every ${billingPeriodValue} weeks`;

    return (
        <>
            By selecting a payment method and proceeding, you agree to automatic subscription renewal. {chargeText} until you cancel in settings before the end of the current period. Learn more in
            {' '}
            <CustomLink
                to={`${legalLinks.termsOfUse}#subscription-fees-and-payment`}
                target='_blank'
            >
                Subscription terms
            </CustomLink>
            {'.'}
        </>
    );
}

export {
    renderAgreementTerms
};
